import { CHANGE_MOBILE_NUMBER, NUMBER_PORT } from '@/config/common';
import { IError, IDocumentList } from './models/accountModel';

export const convertFileToDataUrl = (documentName) => async (file, i) => {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader: any = new FileReader();

    reader.readAsDataURL(file); // read the binary data and encode it as base64 data url.
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = (error: IError) => reject(error);
  });
  return {
    fileName: file.name,
    documentName: `${documentName}_${Date.now()}_${i}`,
    base64Data: dataUrl
  };
};

export const convertAllFilesToDataUrl = async (files, documentName) => {
  const filesPromises = files.map(convertFileToDataUrl(documentName));
  return Promise.all(filesPromises);
};

export const getMediaType = (ext) => {
  const imageExtensons = ['jpg', 'jpeg', 'png', 'gif'];
  const applicationExtensons = ['pdf'];
  if (imageExtensons.includes(ext)) {
    return `image/${ext}`;
  } else if (applicationExtensons.includes(ext)) {
    return `application/${ext}`;
  }
  return ext;
};

export const getFileNameExtension = (fileName) => {
  return fileName?.match(/\w{2,10}$/i)[0];
};

export const getBase64DataUrl = (data) => {
  const { fileName, base64Data } = data;
  const ext = getFileNameExtension(fileName);
  const mediaType = getMediaType(ext);
  return `data:${mediaType};base64,${base64Data}`;
};

export const deleteDocument = (documents, deleteId) => documents.filter((document) => document.documentId !== deleteId);

export const getDocumentsWithDocumentType = (uploadedDocuments, documentType) =>
  uploadedDocuments.map((doc) => ({
    ...doc,
    documentType
  }));

export const filterDocuments = (documents, config) =>
  documents?.filter((document) => document.documentType === config.documentType);

export const getDocumentStatus = (documentList: IDocumentList[] = []) =>
  documentList && documentList.length > 0 && documentList[0].status;

export const getTextHeader = (shoppingCartType) => {
  if (shoppingCartType === NUMBER_PORT) {
    return 'SERVICE_NUM_NUMBERPORT_MOBILE_NUMBER_TITLE'
  }
  return 'SERVICE_NUM_MOBILE_NUMBER_TITLE'
}

export const getNewServiceNumber = (shoppingCartType, isNewServiceNoLoading) => {
  if (shoppingCartType === CHANGE_MOBILE_NUMBER && isNewServiceNoLoading) return true;
  return false;
}

export const getNumberSelection = (isRecontract, isNumberPort) => {
  if (isRecontract || isNumberPort) return true;
  return false;
}

export const getExceededError = (selectedNumbers, limitSelection) => {
  if (selectedNumbers && selectedNumbers.length > limitSelection) return true;
  return false;
}

export const getWaiverHeader = (getWaiverAll) => {
  if (getWaiverAll) return 'REVIEW_ORDER_PENALTY_REQUEST_WAIVER_ALL';
  return 'REVIEW_ORDER_PENALTY_UNDO_WAIVER_ALL';
}

export const getMonthlyTitle = (page) => {
  if (page) return 'TRANSACTION_HISTORY_SVC_TITLE';
  return 'CART_DETAILS_SVC_NUMBER_TITLE';
}